import { useState } from 'react';
import { logError } from '../../utils/utils';

const PlaidItem = ({ institutionId, institutionName, itemId, accessToken }) => {

    const timeout = 5000;
    const [institutionIdCopied, setInstitutionId] = useState(false);
    const [institutionNameCopied, setInstitutionName] = useState(false);
    const [accessTokenCopied, setAccessTokenCopied] = useState(false);
    const [itemIdCopied, setItemIdCopied] = useState(false);

    const clearAll = () => {
        setInstitutionId(false);
        setInstitutionName(false);
        setAccessTokenCopied(false);
        setItemIdCopied(false);
    }

    const handleCopyInstitutionId = async () => {
        clearAll();

        try {
            if (institutionId) {
                await navigator.clipboard.writeText(institutionId);
                setInstitutionId(true);
            }
        } catch (err) {
            logError(err)
        }
        setTimeout(() => {
            setInstitutionId(false);
        }, timeout);
    };

    const handleCopyInstitutionName = async () => {
        clearAll();

        try {
            if (institutionName) {
                await navigator.clipboard.writeText(institutionName);
                setInstitutionName(true);
            }
        } catch (err) {
            logError(err)
        }
        setTimeout(() => {
            setInstitutionName(false);
        }, timeout);
    };

    const handleCopyItemId = async () => {
        clearAll();

        try {
            if (itemId) {
                await navigator.clipboard.writeText(itemId);
                setItemIdCopied(true);
            }
        } catch (err) {
            logError(err)
        }
        setTimeout(() => {
            setItemIdCopied(false);
        }, timeout);
    };

    const handleCopyAccessToken = async () => {
        clearAll();

        try {
            if (accessToken) {
                await navigator.clipboard.writeText(accessToken);
                setAccessTokenCopied(true);
            }
        } catch (err) {
            logError(err)
        }

        setTimeout(() => {
            setAccessTokenCopied(false);
        }, timeout);
    };

    return (
        <>
            <h4 className={'plaid-subtitle'}>
                Congrats! By linking an account, you have created an{' '}
                <a className={'plaid-subtitle-link'} href='http://plaid.com/docs/quickstart/glossary/#item' target='_blank' rel="noreferrer">Item</a>.
            </h4>
            <div className={'plaid-item-access-container'}>

                <p className={'plaid-item-access-row'}>
                    <span className={'plaid-id-name'}>institution_id</span>
                    <span className={'plaid-token-text'}>{institutionId}</span>
                    <span className={'plaid-token-copy-icon'}>
                        <i onClick={handleCopyInstitutionId} className={`fa fa-solid ${institutionIdCopied ? 'fa-check' : 'fa-copy'}`}></i>
                    </span>
                </p>

                <p className={'plaid-item-access-row plaid-item-access-row-last'}>
                    <span className={'plaid-id-name'}>institution_name</span>
                    <span className={'plaid-token-text'}>{institutionName}</span>
                    <span className={'plaid-token-copy-icon'}>
                        <i onClick={handleCopyInstitutionName} className={`fa fa-solid ${institutionNameCopied ? 'fa-check' : 'fa-copy'}`}></i>
                    </span>
                </p>

                <p className={'plaid-item-access-row plaid-item-access-row-last'}>
                    <span className={'plaid-id-name'}>item_id</span>
                    <span className={'plaid-token-text'}>{itemId}</span>
                    <span className={'plaid-token-copy-icon'}>
                        <i onClick={handleCopyItemId} className={`fa fa-solid ${itemIdCopied ? 'fa-check' : 'fa-copy'}`}></i>
                    </span>
                </p>

                <p className={'plaid-item-access-row plaid-item-access-row-last'}>
                    <span className={'plaid-id-name'}>access_token</span>
                    <span className={'plaid-token-text'}>{accessToken}</span>
                    <span className={'plaid-token-copy-icon'}>
                        <i onClick={handleCopyAccessToken} className={`fa fa-solid ${accessTokenCopied ? 'fa-check' : 'fa-copy'}`}></i>
                    </span>
                </p>

            </div>
        </>
    )
}

PlaidItem.displayName = 'Item'

export default PlaidItem
